import { render, staticRenderFns } from "./viber.vue?vue&type=template&id=cabd7620&scoped=true"
import script from "./viber.vue?vue&type=script&lang=js"
export * from "./viber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cabd7620",
  null
  
)

export default component.exports